
import { defineComponent, PropType } from 'vue'
import { useTipsModel } from '@entities/tips'
import { useOrderModel } from '@entities/order'

export default defineComponent({
  name: 'ServiceFee',

  props: {
    sum: {
      type: String as PropType<string>,
      required: true,
      default: '0'
    },
    active: {
      type: Boolean as PropType<boolean>,
      required: true,
      default: true
    },
    currencyIcon: {
      type: String as PropType<string>,
      required: false,
      default: ''
    },
    showTips: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: false
    }
  },

  emits: ['toggleActiveServiceFee'],

  setup () {
    const orderModel = useOrderModel()
    const tipsModel = useTipsModel()

    return {
      orderModel,
      tipsModel
    }
  },

  computed: {
    newText (): boolean {
      if (this.orderModel.orderData) {
        return !this.orderModel.orderData.waiter || this.tipsModel.tipsSum === 0 || !this.tipsModel.tipsSum
      }
      return false
    }
  }
})
